var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-actions-menu"},[_c('div',{staticClass:"menu"},_vm._l((_vm.menu),function(item){return _c('span',{key:("item_" + (item.id)),class:[
        'item',
        {'active' : item.id === _vm.activeId },
        {'hidden' : item.status === false } ],on:{"click":function($event){return _vm.openItem(item.id)}}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }